"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The TouchpointUpdateRequest model module.
 * @module model/TouchpointUpdateRequest
 * @version 1.0.0
 */
var TouchpointUpdateRequest = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TouchpointUpdateRequest</code>.
   * @alias module:model/TouchpointUpdateRequest
   * @param title {String} 
   * @param _date {String} 
   */
  function TouchpointUpdateRequest(title, _date) {
    _classCallCheck(this, TouchpointUpdateRequest);

    TouchpointUpdateRequest.initialize(this, title, _date);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(TouchpointUpdateRequest, null, [{
    key: "initialize",
    value: function initialize(obj, title, _date) {
      obj['title'] = title;
      obj['date'] = _date;
    }
    /**
     * Constructs a <code>TouchpointUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TouchpointUpdateRequest} obj Optional instance to populate.
     * @return {module:model/TouchpointUpdateRequest} The populated <code>TouchpointUpdateRequest</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TouchpointUpdateRequest();

        if (data.hasOwnProperty('title')) {
          obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
        }

        if (data.hasOwnProperty('date')) {
          obj['date'] = _ApiClient.default.convertToType(data['date'], 'String');
        }

        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient.default.convertToType(data['category'], 'String');
        }

        if (data.hasOwnProperty('duration')) {
          obj['duration'] = _ApiClient.default.convertToType(data['duration'], 'String');
        }

        if (data.hasOwnProperty('services_provided')) {
          obj['services_provided'] = _ApiClient.default.convertToType(data['services_provided'], 'String');
        }

        if (data.hasOwnProperty('notes')) {
          obj['notes'] = _ApiClient.default.convertToType(data['notes'], 'String');
        }
      }

      return obj;
    }
  }]);

  return TouchpointUpdateRequest;
}();
/**
 * @member {String} title
 */


TouchpointUpdateRequest.prototype['title'] = undefined;
/**
 * @member {String} date
 */

TouchpointUpdateRequest.prototype['date'] = undefined;
/**
 * @member {String} category
 */

TouchpointUpdateRequest.prototype['category'] = undefined;
/**
 * @member {String} duration
 */

TouchpointUpdateRequest.prototype['duration'] = undefined;
/**
 * @member {String} services_provided
 */

TouchpointUpdateRequest.prototype['services_provided'] = undefined;
/**
 * @member {String} notes
 */

TouchpointUpdateRequest.prototype['notes'] = undefined;
var _default = TouchpointUpdateRequest;
exports.default = _default;